import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';

export const NewsBondsTitle = () => (
  <ouiDom.HeadingSection.DomH2
    fontSize="xs"
    lineFactor={[1.75, undefined, undefined, 1.5, undefined, undefined]}
    paddingTop="half"
    paddingBottom="simple"
    paddingHorizontal={['double', undefined, undefined, 'none', undefined, undefined]}
    color={ouiStyle.Constants.Colors.logoBlue}
  >
    <Trans>
      Obligations
    </Trans>
  </ouiDom.HeadingSection.DomH2>
);
